import { useTranslation } from "react-i18next";
import { Box, MenuItem, SelectProps } from "@material-ui/core";
import { Label } from "components/Styled";
import SelectField from "components/Forms/SelectField";
import useOrganization from "utils/useOrganization";
import { useRuleContext } from "../../context/ruleContext";
import { getCloudStorage } from "../../context/ruleSelectors";

import { ShareRetention } from "@dashboard-v3/api";

type ShareRetentionOption = ShareRetention | "DEFAULT";

export default function FileRetentionSelector() {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const storage = getCloudStorage(state.rule);
  const { organization } = useOrganization();
  const orgRetention = organization?.mxheroStorage?.retention || "ONE_YEAR";
  const period = t(`cloudStorage.retention.${orgRetention}`);

  const onRetentionChange: SelectProps["onChange"] = e => {
    const { value } = e.target;
    const changes = { retention: value };

    if (value === "DEFAULT") {
      changes.retention = null;
    }

    dispatch({
      type: "updateStep",
      payload: { step: "cloudStorage", changes },
    });
  };

  return (
    <Box mb={3}>
      <Label wording={t("cloudStorage.retention.label")} />
      <SelectField<ShareRetentionOption>
        name="retention"
        options={retentionPeriodOptions}
        onChange={onRetentionChange}
        value={storage.retention || "DEFAULT"}
        renderOption={opt => (
          <MenuItem key={opt} value={opt}>
            {t(`cloudStorage.retention.${opt}`, { period })}
          </MenuItem>
        )}
      />
    </Box>
  );
}

const retentionPeriodOptions: ShareRetentionOption[] = [
  "DEFAULT",
  "SEVEN_DAYS",
  "FOURTEEN_DAYS",
  "THIRTY_DAYS",
  "SIXTY_DAYS",
  "NINETY_DAYS",
  "ONE_HUNDRED_EIGHTY_DAYS",
  "ONE_YEAR",
  "TWO_YEARS",
  "THREE_YEARS",
  "FOUR_YEARS",
  "FIVE_YEARS",
  "SIX_YEARS",
  "SEVEN_YEARS",
  "TEN_YEARS",
  "PERMANENT",
];
